import fetch from 'isomorphic-fetch';
import queryString from 'query-string';
import { modal } from 'react-redux-modal';
import { checkHttpStatus, parseJSON } from '../utils';
import _ from 'lodash';
import PanelsSavedModal from '../components/Modals/PanelsSaved';
import {
  TOGGLE_COMMENTS_WIDTH,
  TOGGLE_RELATED_SNAPSHOTS,
  SHOW_RELATED_SNAPSHOTS,
  TOGGLE_INFO_PANELS,
  SET_BACKGROUND_PREFERENCE,
  AUTH_USER_INFO_PANELS,
  CHANGE_VIEW_MODE,
  SET_NOTIFICATION_EXCEPTIONS,
} from '../constants';
import EXPLORE_API from '../constants/symbols';
import ExploreAuth from '../utils/ExploreAuth';
import { authLogoutAndRedirect } from './auth';
import BrowserStore from 'store2';

export function toggleCommentsWidth() {
  return (dispatch, getState) => {
    const state = getState();
    let commentsFullWidth = !state.uiPreferences.commentsFullWidth;
    if (state.auth.isAuthenticated) {
      ExploreAuth.getValidJwt()
        .then((tokenIsValid) => {
          // Token can't be refreshed log them out
          if (!tokenIsValid) {
            // We should probably add a modal here informing them they need to log back in.
            return dispatch(authLogoutAndRedirect());
          }

          fetch(`${SERVER_URL}/accounts/save_user_preferences`, {
            method: 'post',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
              Authorization: `Bearer ${ExploreAuth.getJwt()}`,
            },
            body: queryString.stringify({ comments_only: commentsFullWidth })
          })
            .then(checkHttpStatus)
            .then(parseJSON)
            .then(({ data }) => {
              if (BrowserStore.session.get('user')) {
                const user = BrowserStore.session.get('user');
                if (user) {
                  user.preferences = data;
                  BrowserStore.session.set('user', user);
                }
              }
            })
            .catch(error => {
              //Error submitting user preferences
            });
        });

    }
    return dispatch({
      type: TOGGLE_COMMENTS_WIDTH,
      payload: {
        commentsFullWidth
      }
    });
  };
}

export function toggleRelatedSnapshots() {
  return {
    type: TOGGLE_RELATED_SNAPSHOTS
  };
}

export function showRelatedSnapshots() {
  return {
    type: SHOW_RELATED_SNAPSHOTS
  };
}

export function toggleInfoPanel(panelName) {
  return (dispatch, getState) => {
    const state = getState();
    let { infoPanels } = state.uiPreferences;
    infoPanels[panelName] = !infoPanels[panelName];
    if (state.auth.isAuthenticated) {
      ExploreAuth.getValidJwt()
        .then((tokenIsValid) => {
          // Token can't be refreshed log them out
          if (!tokenIsValid) {
            // We should probably add a modal here informing them they need to log back in.
            return dispatch(authLogoutAndRedirect());
          }

          fetch(`${SERVER_URL}/accounts/save_user_preferences`, {
            method: 'post',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
              Authorization: `Bearer ${ExploreAuth.getJwt()}`,
            },
            body: queryString.stringify({ info_panels: JSON.stringify(infoPanels) })
          })
            .then(checkHttpStatus)
            .then(parseJSON)
            .then(response => {
              if (!state.auth.infoPanels) {
                dispatch({ type: AUTH_USER_INFO_PANELS });
                modal.add(PanelsSavedModal, {
                  hideTitleBar: true,
                  title: '',
                  size: 'small',
                });
              }
            })
            .catch(error => {
              //Error submitting user preferences
            });
        });
    }
    dispatch({
      type: TOGGLE_INFO_PANELS,
      payload: {
        data: infoPanels
      }
    });
  };
}
export function setNotificationExceptions(exceptions) {
  return (dispatch, getState) => {
    const state = getState();
    if (state.auth.isAuthenticated) {
      ExploreAuth.getValidJwt()
        .then((tokenIsValid) => {
          // Token can't be refreshed log them out
          if (!tokenIsValid) {
            // We should probably add a modal here informing them they need to log back in.
            return dispatch(authLogoutAndRedirect());
          }

          fetch(`${SERVER_URL}/accounts/save_user_preferences`, {
            method: 'post',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
              Authorization: `Bearer ${ExploreAuth.getJwt()}`,
            },
            body: queryString.stringify({ notification_exceptions: JSON.stringify(exceptions) })
          })
            .then(checkHttpStatus)
            .then(parseJSON)
            .then(response => {
              // if (!state.auth.infoPanels) {
              //   dispatch({ type: AUTH_USER_INFO_PANELS });
              //   modal.add(PanelsSavedModal, {
              //     hideTitleBar: true,
              //     title: '',
              //     size: 'small',
              //   });
              // }
            })
            .catch(error => {
              //Error submitting user preferences
            });
        });
    }
    dispatch({
      type: SET_NOTIFICATION_EXCEPTIONS,
      payload: {
        data: exceptions,
      },
    });
  };
}

export function setUserPreferences(preferences) {
  return dispatch => {
    if (!preferences) return;
    const { info_panels, comments_only, background, notification_exceptions } = preferences;
    if (info_panels && Object.keys(info_panels).length > 0) {
      dispatch({
        type: TOGGLE_INFO_PANELS,
        payload: {
          data: preferences.info_panels
        }
      });
    }
    if (notification_exceptions) {
      dispatch({
        type: SET_NOTIFICATION_EXCEPTIONS,
        payload: {
          data: notification_exceptions,
        },
      });
    }

    if (comments_only) {
      dispatch({
        type: TOGGLE_COMMENTS_WIDTH,
        payload: {
          commentsFullWidth: preferences.comments_only
        }
      });
    }

    if (background) {
      dispatch({
        type: SET_BACKGROUND_PREFERENCE,
        payload: {
          backgroundChoice: background.value
        }
      });
    }
  };
}

export function changeViewMode(data) {
  return (dispatch, getState) => {
    let state = getState();
    if(_.get(state, 'auth.isAuthenticated')) {
      return dispatch({
        type: CHANGE_VIEW_MODE,
        [EXPLORE_API]: {
          url: 'view_mode',
          method: 'POST',
          body: {
            view_mode: data
          }
        },
        payload: {
          data
        }
      });
    } else {
      return dispatch({
        type: CHANGE_VIEW_MODE,
        payload: {
          data
        }
      })
    }
  }
}
